import './workout-exercises.css';
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Routes from "../../assets/RoutesToPages/Routes";
import Lottie from 'react-lottie';
import {WorkoutContent} from "../../assets/WorkoutContent";
import {useDispatch} from "react-redux";
import {createWorkoutSetupData} from "../../store/slices/workoutSetup";
import {ReactComponent as WorkoutExercisesContentLogo} from './img-workout-exercises/main-img.svg';


const WorkoutExercisesPage = () => {
  const navigate = useNavigate();
  const localWorkoutSetupData = JSON.parse(localStorage.getItem('workoutSetupData'));
  const workoutExercises = WorkoutContent['exercise-type'][localWorkoutSetupData['exerciseName']]
    [localWorkoutSetupData.character][localWorkoutSetupData.difficulty];
  const specifiedTime = WorkoutContent['exercise-type'][localWorkoutSetupData['exerciseName']]
    ['mode-time'][localWorkoutSetupData.difficulty];
  const dispatch = useDispatch();
  const [isMusicActive, setIsMusicActive] = useState(
    localWorkoutSetupData ? localWorkoutSetupData.music === 'yes' : false);
  const userWorkoutExercisesRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (userWorkoutExercisesRef.current) {
      userWorkoutExercisesRef.current.classList.add('user-workout-exercises-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      userWorkoutExercisesRef.current.classList.remove('user-workout-exercises-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);

  const handleToggleMusic = () => {
    setIsMusicActive(!isMusicActive)
  }

  useEffect(() => {
    if (!localWorkoutSetupData) {
      return;
    }
    if (!isMusicActive) {
      dispatch(createWorkoutSetupData({...localWorkoutSetupData, music: "no"}))
    } else {
      dispatch(createWorkoutSetupData({...localWorkoutSetupData, music: "yes"}))
    }
  }, [isMusicActive, localWorkoutSetupData]);

  const handleStartTraining = () => {
    navigate(Routes.workoutStartTraining);
  }

  useEffect(() => {
    if (!localWorkoutSetupData) {
      localStorage.removeItem('workoutSetupData');
      navigate(Routes.mainPage);
    }
  }, [localWorkoutSetupData]);

  if (!localWorkoutSetupData) {
    return null;
  }

  const exerciseData = WorkoutContent['exercise-type']?.[localWorkoutSetupData['exerciseName']];
  const modeTime = exerciseData?.['mode-time']?.[localWorkoutSetupData.difficulty];

  if (!exerciseData || !modeTime) {
    return null;
  }

  return (
    <div ref={userWorkoutExercisesRef}
         className='workout-exercises-container'>
      <p className='workout-exercises__title'>{[localWorkoutSetupData['exerciseName']]}</p>
      <div className='workout-exercises-content'>
        <WorkoutExercisesContentLogo className="workout-exercises-content-logo"
                                     width='131'
                                     height='134'/>
        <div className='workout-navigation__exercises'>
          <img className='workout-navigation__arrow'
               loading="lazy"
               onClick={() => navigate(-1)}
               src={require("./img-workout-exercises/back_arrow.svg").default}
               width='24'
               height='24'
               alt="image arrow left">
          </img>
          <div className='music-calendar-container'>
            <img className='workout-navigation__music'
                 onClick={handleToggleMusic}
                 loading="lazy"
                 src={isMusicActive ?
                   require("./img-workout-exercises/icon-music-on.svg").default :
                   require("./img-workout-exercises/icon-music-off.svg").default}
                 width='24'
                 height='24'
                 alt="icon calendar">
            </img>
            <img className='workout-navigation__calendar'
                 onClick={() => navigate(Routes.calendarPage)}
                 loading="lazy"
                 src={require("./img-workout-exercises/calendar-icon.svg").default}
                 width='24'
                 height='24'
                 alt="icon calendar">
            </img>
          </div>
        </div>
        <div className='workout-specified-mode-panel'>
          <p className='workout-exercises-mode'>{`Mode: ${localWorkoutSetupData.difficulty}`}</p>
          <p className='workout-exercises-time'>{`Time: ${specifiedTime}`}</p>
        </div>
        <div className='workout-type-exercises-container'>
          {workoutExercises.map(exerciseType => (
              <div key={exerciseType.id}
                   className='workout-type-exercise'>
                <div className={`img-type-exercise img-type-exercise-${exerciseType.id}`}>
                  <Lottie
                    loading="lazy"
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: exerciseType.image,
                      rendererSettings: {
                        preserveAspectRatio: 'xMidYMid meet',
                      }
                    }}
                    isClickToPauseDisabled={true}
                    width={exerciseType.width}
                    height={exerciseType.height}
                  />
                </div>
                <div className='workout-type-exercise__description'>
                  <p className='workout-type-exercise__title'>{exerciseType.title}</p>
                  <p className='workout-type-exercise__subtitle'>{exerciseType.subtitle}</p>
                </div>
              </div>
            )
          )}
          <p className='workout-exercise-recommendation'>
            Before starting the exercises, we recommend to do a warm-up
          </p>
          <button onClick={handleStartTraining}
                  className='workout-exercises-btn'>
            Start
          </button>
        </div>
      </div>
    </div>
  )
}

export default WorkoutExercisesPage;